import moment from "moment";

export function combineDateWithTime(inp: Date, time: string) {
  const date = moment(inp).toDate();

  const hoursAndMinutes = time.split(":");
  const hours = Number(hoursAndMinutes[0]);
  const minutes = Number(hoursAndMinutes[1]);

  date.setHours(hours);
  date.setMinutes(minutes);
  date.setSeconds(0);
  date.setMilliseconds(0);

  return date;
}
